import styled, { createGlobalStyle } from 'styled-components';
import Button from '@sy/app-client/src/ssrAdapter/components/Button';
import Logo from '@sy/app-client/src/ssrAdapter/components/Logo';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const HeaderWrapper = styled.div`
	height: 88px;
	max-width: 1352px;
	margin: 0 auto;
	position: relative;
	border-bottom-color: ${({ theme }) => theme.colors.grey[200]};
	${media.belowLarge`
		height: 64px;
		width: 100%;
		border-bottom-width: 1px;
		border-bottom-style: solid;
	`}
`;

export const StyledHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.white};
	height: 100%;
`;

export const Inner = styled.header`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;
	margin-left: auto;
	margin-right: auto;
	max-width: 1352px;
	height: 88px;
	${media.belowLarge`
		height: 64px;
		width: 100%;
	`}
`;

export const Navigation = styled.ul`
	flex: 1;
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 32px;
	list-style-type: none;
	margin: 0;

	${media.belowLarge`
		display: none;
	`}
`;

type CategoryLinkTypes = {
	active?: boolean;
};
export const CategoryLink = styled.a<CategoryLinkTypes>`
	font-size: 1.6rem;
	font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
	line-height: 2.4rem;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.black};
	text-decoration: none;
	position: relative;

	&:hover::after,
	&:focus::after {
		content: '';
		position: absolute;
		left: 0;
		right: auto;
		width: 100%;
		top: 100%;
		height: 2px;
		background-color: ${({ theme }) => theme.colors.black};
	}
`;

export const VerticalNavigation = styled.ul`
	top: 100%;
	right: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 24px;
	z-index: 2;
	list-style-type: none;
	margin: 0;
`;

export const TryStreamYard = styled.div`
	${media.belowLarge`
		display: none;
	`}
`;

export const TryStreamYardButton = styled(Button)`
	span {
		font-size: 1.4rem;
		font-weight: 600;
	}
`;

export const MenuIconWrapper = styled.div`
	display: none;
	${media.belowLarge`
		display: block;
	`}
`;

export const StyledLogo = styled(Logo)`
	width: 135px;
	height: 24px;

	${media.large`
		width: 180px;
		height: 32px;
  `};
`;

type GlobalStylesTypes = {
	disableScroll?: boolean;
};
export const GlobalStyles = createGlobalStyle<GlobalStylesTypes>`
	body {
		overflow: ${({ disableScroll }) => (disableScroll ? 'hidden' : 'inherit')};
	}
`;
